import React from 'react';

import { NavGroupL2, NavGroupTitleL2, NavItemL2, ListItemText, Button } from '@mesh.ai/rabbit';
import { staticRoutes } from 'Deer/constants/routes';
import { getUserAccess, getUserL2Access } from 'Deer/helpers/getUserAccess';
import { NavLink } from 'react-router-dom';

import { ArrowRight, Settings } from 'assets/assetsV1/iconComponents';

import { TextLabel } from 'uiToolkitV1/Typography';

import { ModuleSection } from './ModuleSection';

const GoToPlatformSettings = () => (
  <NavLink to={staticRoutes.company.settings.platform.organization}>
    <Button variant="text" style={{ padding: '0 5px', width: '220px' }}>
      <Settings boxSize="24px" color="#0D819F" />
      <TextLabel bold color="#0D819F">
        Go to Company Settings
      </TextLabel>
      <ArrowRight boxSize="20px" color="#0D819F" />
    </Button>
  </NavLink>
);

const MySettingsSection = () => (
  <NavGroupL2>
    <NavGroupTitleL2>MY SETTINGS</NavGroupTitleL2>
    <NavLink to={staticRoutes['my-data']['my-settings'].notifications} activeClassName="active-L2">
      <NavItemL2>
        <ListItemText title="Notifications" />
      </NavItemL2>
    </NavLink>
    {/* Calendar Settings for 1:1s */}
    {getUserL2Access().hasOneOnOneAccess && (
      <NavLink to={staticRoutes['my-data']['my-settings'].calendar} activeClassName="active-L2">
        <NavItemL2>
          <ListItemText title="Calendar" />
        </NavItemL2>
      </NavLink>
    )}
    {/*  Disabling  the knowledge hub for now . It may be enabled in future */}
    {/* {getUserL2Access().hasOneOnOneAccess && (
      <NavLink to={staticRoutes['my-data']['my-settings'].knowledgeHub} activeClassName="active-L2">
        <NavItemL2>
          <ListItemText title="Knowledge Hub" />
        </NavItemL2>
      </NavLink>
    )} */}
  </NavGroupL2>
);

export const MyDataSecondaryNav = () => {
  const { isPlatformAdmin = false } = getUserAccess();
  return (
    <>
      <ModuleSection />
      <MySettingsSection />
      {isPlatformAdmin ? <GoToPlatformSettings /> : null}
    </>
  );
};
